import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { DataProvider } from './util/dataProvider';
import initReactFastclick from 'react-fastclick';
import SimpleReactLightbox from 'simple-react-lightbox';

initReactFastclick();

ReactDOM.render(
	<React.StrictMode>
		<DataProvider>
			<SimpleReactLightbox>
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</SimpleReactLightbox>
		</DataProvider>
	</React.StrictMode>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
